import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';


// Components

import SummaryItem from '../SummaryItem';

// Utils

import { DATE_FORMATS } from '@utils/dates/dateMethods';
import { formatDate, subtractFromDateWithFormat, toUTCAndFormat } from '@utils/dates/date.utils';
import { questionsVisibility } from '@utils/miscellaneous/pageAndQuestionsVisibility';
import { YYYY } from '@utils/dates/dateFormats.utils';

// Constants

import { NO_PRIOR_DATA } from '@constants/ssap/miscellaneous/miscellaneous';

const MedicaidChipInfo = props => {

    const {
        DATE_FORMAT
    } = DATE_FORMATS;

    const {
        changeInImmigrationSince5Year,
        changeInImmigrationSinceMedicaidDenial,
        exchangeAndProgramNames,
        idx,
        isState,
        bhpDenied,
        bhpDenialDate,
        medicaidChipDenial,
        medicaidDeniedDate,
        medicaidDeniedDueToImmigration,
        medicaidEndDateOverride,
        medicaidTerminationFeatureEnabled,
        member,
        serverDate
    } = props;

    const intl = useIntl();
    const { exchangeMedicaid, exchangeChip, exchangeMedicaidOrChip } = exchangeAndProgramNames;
    const isVisible = questionsVisibility.isMedicaidChipDenialShown({
        hhm: member,
        medicaidTerminationFeatureEnabled,
        serverDate,
        medicaidEndDateOverride
    });

    if (!isVisible) {
        return null;
    }

    const fiveYearsAgo = subtractFromDateWithFormat(5, 'year', YYYY, serverDate);

    const getMedicaidDeniedDate = (date, isPrevious = false) => {
        // This is a small helper to return a custom message.
        if(formatDate(date, DATE_FORMAT) === 'Invalid Date') {
            return isPrevious ? NO_PRIOR_DATA : intl.formatMessage({ id: 'common.not_available' });
        }
        return toUTCAndFormat(date, DATE_FORMAT);
    };
    
    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.medicaid_not_eligible'
                replacements={{ exchangeMedicaid, exchangeMedicaidOrChip } }
                value = { medicaidChipDenial }
                noPriorDataValues = { [ null ] }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].medicaidChipDenial`
                        ]
                    ]
                }
            />
            {
                medicaidChipDenial &&

                <Fragment>
                    <SummaryItem
                        textCode='common.medicaid_denied_chip'
                        replacements={{ exchangeMedicaid, exchangeMedicaidOrChip }}
                        value = { getMedicaidDeniedDate(medicaidDeniedDate) }
                        ignoreIntl
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].medicaidDeniedDate`,
                                    getMedicaidDeniedDate,
                                    [ true ]
                                ]
                            ]
                        }
                    />
                    <SummaryItem
                        category = 'common.medicaid_not_eligible_since'
                        replacements = { {
                            fiveYearsAgo,
                            exchangeMedicaid,
                            exchangeMedicaidOrChip
                        } }
                        value = { medicaidDeniedDueToImmigration }
                        noPriorDataValues = { [ null ] }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].medicaidDeniedDueToImmigration`
                                ]
                            ]
                        }
                    />
                    {
                        medicaidDeniedDueToImmigration &&

                        <Fragment>
                            <SummaryItem
                                category = 'common.change_in_is_since'
                                replacements = { {
                                    fiveYearsAgo
                                } }
                                value = { changeInImmigrationSince5Year }
                                noPriorDataValues = { [ null ] }
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].changeInImmigrationSince5Year`
                                        ]
                                    ]
                                }
                            />
                            {
                                changeInImmigrationSince5Year &&

                                <SummaryItem
                                    textCode = 'common.immigration_status_change_medicaid'
                                    replacements={{ exchangeMedicaidOrChip }}
                                    value = { changeInImmigrationSinceMedicaidDenial }
                                    noPriorDataValues = { [ null ] }
                                    desc = {
                                        [
                                            [
                                                `taxHousehold.householdMember[${ idx }].changeInImmigrationSinceMedicaidDenial`
                                            ]
                                        ]
                                    }
                                />
                            }
                        </Fragment>
                    }
                </Fragment>
            }

            {
                isState.MN &&
                <Fragment>
                    <SummaryItem
                        textCode='common.bhp_not_eligible'
                        replacements={{ exchangeMedicaid, exchangeMedicaidOrChip }}
                        value={bhpDenied}
                        noPriorDataValues = { [ null ] }
                        desc={
                            [
                                [
                                    `taxHousehold.householdMember[${idx}].bhpDenied`
                                ]
                            ]
                        }
                    />
                    {
                        bhpDenied &&
                        <SummaryItem
                            textCode='common.bhp_denied_date'
                            replacements={{ exchangeMedicaid, exchangeChip, exchangeMedicaidOrChip }}
                            value={getMedicaidDeniedDate(bhpDenialDate)}
                            ignoreIntl
                            desc={
                                [
                                    [
                                        `taxHousehold.householdMember[${idx}].bhpDenialDate`,
                                        getMedicaidDeniedDate,
                                        [ true ]
                                    ]
                                ]
                            }
                        />
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default MedicaidChipInfo;